<template>
  <main class="main page-inside payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title big">{{ $t(`Your payment is currently processing, please wait!`) }}</div>
          <div class="loader" style="margin-top: 30px;"></div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PaymentSuccessPage',
  props: [],

  components: {
  },

  mounted() {
    this.checkStatus();
    this.interval = setInterval(this.checkStatus, 10000);
  },

  data: function() {
    return {
      interval: null
    }
  },

  methods: {
    checkStatus() {
        this.$http.get('deposit/status', {params: {
             order_id: this.$route.query.order_id
          }})
            .then(({data}) => {
              if (data.status == "OK") {
                if (data.order.redirect_url) {
                  window.location = data.order.redirect_url;
                }

                if (data.order.status !== 'pending') {
                  if (data.order.status === 'success') {
                    this.$router.push('/success-payment')
                  } else if(data.order.state === 'error') {
                    this.$router.push('/fail-payment')
                  }
                  clearInterval(this.interval);
                }
              } else {
                clearInterval(this.interval);
              }
            })
            .catch((res) => {
              console.log(res);
            })
    },
  },
});
</script>